import { useTranslation } from "react-i18next";
import { useStyle } from "./style";
import { IError } from "itsf-ui-common";
import { useStancerPaymentIframe } from "./useStancerPaymentIframe";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";

interface IParams {
    validatePaymentApiRoute: string;
    iframePaymentApiRoute: string;
    successCallback(): void;
    errorCallback?(error: IError): void;
}

export const StancerPaymentIframe = (props: IParams) => {
    const { validatePaymentApiRoute, iframePaymentApiRoute, successCallback, errorCallback } = props;
    const { t } = useTranslation("summary");
    const { classes } = useStyle();

    const {
        iframeKey,
        getIFrame,
        iframeFetchState: { isLoading, error },
        hpp,
    } = useStancerPaymentIframe({
        validatePaymentApiRoute,
        iframePaymentApiRoute,
        successCallback,
        errorCallback,
    });

    return (
        <HandleErrorAndLoading error={error} isLoading={isLoading} retryFetch={getIFrame}>
            {hpp && (
                <iframe
                    className={classes.iframe}
                    id="target-iframe"
                    key={iframeKey}
                    src={hpp.url}
                    title={t("paymentIframe")}
                />
            )}
        </HandleErrorAndLoading>
    );
};
